// Chef&Nutri — comportamento compartilhado por todas as páginas: menu mobile
// (drawer), animação de revelar ao rolar, quick view e mini carrinho.
// Adicionar ao carrinho de verdade (AJAX) é feito pelo próprio wc-add-to-cart.js
// do WooCommerce nos botões .ajax_add_to_cart — este arquivo só abre/fecha os
// paineis e lê os dados do produto já renderizados no DOM (data-qv).
(function () {
	'use strict';

	// Escapa texto vindo do banco antes de entrar em innerHTML. A regra do tema
	// ("todo dado que sai e escapado") vale no JS tambem: nome de tag de produto,
	// titulo de metodo de entrega e nome de produto sao cadastrados no wp-admin,
	// e um "<" ali viraria HTML executavel na pagina do visitante. Onde o valor e
	// so texto, o certo e textContent; onde ele entra numa string de HTML montada
	// aqui, passa por esta funcao.
	function escHtml(value) {
		var mapa = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
		return String(value === null || value === undefined ? '' : value).replace(/[&<>"']/g, function (c) {
			return mapa[c];
		});
	}

	// ---- Menu mobile (drawer) ----
	var menuBtn = document.getElementById('menuBtn');
	var drawerClose = document.getElementById('drawerClose');
	var drawerOverlay = document.getElementById('drawerOverlay');

	function openMenu() { document.body.classList.add('menu-open'); }
	function closeMenu() { document.body.classList.remove('menu-open'); }

	if (menuBtn) menuBtn.addEventListener('click', openMenu);
	if (drawerClose) drawerClose.addEventListener('click', closeMenu);
	if (drawerOverlay) drawerOverlay.addEventListener('click', closeMenu);
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') closeMenu();
	});

	document.querySelectorAll('[data-drawer-toggle]').forEach(function (btn) {
		btn.addEventListener('click', function () {
			var group = btn.closest('.drawer-group');
			if (!group) return;
			var isOpen = group.classList.toggle('is-open');
			btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		});
	});

	// ---- Revelar ao rolar ----
	var revealObserver = null;

	function observeReveal(root) {
		var els = (root || document).querySelectorAll('[data-reveal]:not(.is-revealed)');
		if (!els.length) return;

		if (revealObserver) {
			els.forEach(function (el) { revealObserver.observe(el); });
		} else {
			els.forEach(function (el) { el.classList.add('is-revealed'); });
		}
	}

	if ('IntersectionObserver' in window) {
		revealObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-revealed');
					revealObserver.unobserve(entry.target);
				}
			});
		}, { threshold: 0.12 });
	}

	observeReveal(document);

	// O WooCommerce troca pedaços da página por AJAX (carrinho atualizado,
	// carrinho esvaziado, totais). O conteúdo novo entra sem a classe
	// .is-revealed e, como o CSS deixa [data-reveal] com opacity: 0, ficaria
	// INVISÍVEL — foi o que aconteceu com a newsletter do carrinho vazio depois
	// de remover o último item. Reobservamos a cada troca.
	if (window.jQuery) {
		window.jQuery(document.body).on(
			'updated_wc_div updated_cart_totals wc_cart_emptied updated_checkout',
			function () { observeReveal(document); }
		);
	}

	// ---- Quick view ----
	var qvOverlay = document.getElementById('qvOverlay');
	if (qvOverlay) {
		var qvImage = document.getElementById('qvImage');
		var qvTags = document.getElementById('qvTags');
		var qvName = document.getElementById('qvName');
		var qvSize = document.getElementById('qvSize');
		var qvPrice = document.getElementById('qvPrice');
		var qvDesc = document.getElementById('qvDesc');
		var qvQty = document.getElementById('qvQty');
		var qvLink = document.getElementById('qvLink');
		var qvDec = document.getElementById('qvDec');
		var qvInc = document.getElementById('qvInc');
		var qvAdd = document.getElementById('qvAdd');
		var qvBuyRow = document.getElementById('qvBuyRow');
		var qvOut = document.getElementById('qvOut');
		var qvQtyVal = 1;

		function setQvQuantity(val) {
			qvQtyVal = Math.max(1, val);
			if (qvQty) qvQty.textContent = String(qvQtyVal);
			if (qvAdd) qvAdd.setAttribute('data-quantity', String(qvQtyVal));
		}

		function openQv(data) {
			qvQtyVal = 1;
			if (qvTags) qvTags.innerHTML = (data.tags || []).map(function (t) { return '<span class="tag tag--lg">' + escHtml(t) + '</span>'; }).join('');
			if (qvName) qvName.textContent = data.name || '';
			if (qvSize) qvSize.textContent = data.size || '';
			if (qvPrice) qvPrice.innerHTML = data.priceHtml || '';
			if (qvDesc) qvDesc.textContent = data.desc || '';
			if (qvLink) qvLink.setAttribute('href', data.permalink || '#');
			// imageHtml vem pronto do PHP (wp_get_attachment_image), não montamos
			// a <img> aqui — é o que dá srcset/width/height ao quick view.
			if (qvImage) qvImage.innerHTML = data.imageHtml || '<div class="img-placeholder">' + escHtml(data.name) + '</div>';
			if (qvAdd) qvAdd.setAttribute('data-product_id', String(data.id));

			// Produto esgotado: troca a linha de compra pelo aviso. O botão
			// também é desabilitado — ele carrega as classes .ajax_add_to_cart,
			// e só escondê-lo deixaria o wc-add-to-cart.js do WooCommerce ainda
			// alcançável se algo o exibisse de novo.
			var canBuy = data.canBuy !== false;
			if (qvBuyRow) qvBuyRow.hidden = !canBuy;
			if (qvOut) qvOut.hidden = canBuy;
			if (qvAdd) qvAdd.disabled = !canBuy;

			setQvQuantity(1);
			document.body.classList.add('qv-open');
		}
		function closeQv() { document.body.classList.remove('qv-open'); }

		document.querySelectorAll('[data-quickview]').forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				var raw = btn.getAttribute('data-qv');
				if (!raw) return;
				try { openQv(JSON.parse(raw)); } catch (err) { /* dado inválido, ignora */ }
			});
		});
		qvOverlay.addEventListener('click', closeQv);
		document.querySelectorAll('[data-close-qv]').forEach(function (el) { el.addEventListener('click', closeQv); });
		document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQv(); });
		if (qvDec) qvDec.addEventListener('click', function () { setQvQuantity(qvQtyVal - 1); });
		if (qvInc) qvInc.addEventListener('click', function () { setQvQuantity(qvQtyVal + 1); });
	}

	// ---- Barra de avisos: alterna entre as mensagens ----
	// O PHP já imprime todas (uma por linha do campo no Customizer) empilhadas
	// na mesma célula do grid; aqui só trocamos qual está ativa. O atributo
	// data-announce só existe quando há mais de uma — com uma só, nada roda.
	var barraDeAvisos = document.querySelector('[data-announce]');

	if (barraDeAvisos) {
		var avisos = Array.prototype.slice.call(barraDeAvisos.querySelectorAll('.announce-bar__item'));

		if (avisos.length > 1) {
			var avisoAtual = 0;
			var relogioDosAvisos = null;

			function mostrarAviso(indice) {
				avisos.forEach(function (aviso, n) {
					var ativo = n === indice;
					aviso.classList.toggle('is-active', ativo);

					// aria-hidden acompanha a troca: as mensagens inativas
					// continuam no DOM (só com opacidade 0), e sem isto o leitor
					// de tela leria todas de uma vez.
					if (ativo) {
						aviso.removeAttribute('aria-hidden');
					} else {
						aviso.setAttribute('aria-hidden', 'true');
					}
				});
			}

			function pararAvisos() {
				if (relogioDosAvisos) {
					clearInterval(relogioDosAvisos);
					relogioDosAvisos = null;
				}
			}

			function comecarAvisos() {
				pararAvisos();
				relogioDosAvisos = setInterval(function () {
					avisoAtual = (avisoAtual + 1) % avisos.length;
					mostrarAviso(avisoAtual);
				}, 5000);
			}

			// Conteúdo que troca sozinho precisa poder ser pausado (WCAG 2.2.2):
			// com o ponteiro em cima ou o teclado dentro da faixa, a rotação
			// para — é o tempo de ler até o fim, ou de alcançar um link.
			barraDeAvisos.addEventListener('mouseenter', pararAvisos);
			barraDeAvisos.addEventListener('mouseleave', comecarAvisos);
			barraDeAvisos.addEventListener('focusin', pararAvisos);
			barraDeAvisos.addEventListener('focusout', comecarAvisos);

			comecarAvisos();
		}
	}

	// ---- Vídeo nos cards de produto ----
	// Toca sozinho, mudo e em loop, mas SÓ enquanto o card está na tela. Numa
	// grade de 24 produtos, deixar todos tocando (ou mandar `autoplay` no HTML,
	// que baixa tudo de uma vez) gastaria banda e bateria para vídeos que o
	// visitante talvez nunca role até ver. Por isso o PHP manda preload="none"
	// e sem autoplay — quem decide é este observador.
	var cardVideos = document.querySelectorAll('[data-card-video]');

	if (cardVideos.length) {
		var pedeMenosMovimento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		var bloqueados = [];

		// O celular só libera reprodução automática com o vídeo MUDO, e quem a
		// política consulta é a PROPRIEDADE, não o atributo do HTML. Garantimos
		// as duas aqui: é o motivo nº 1 de autoplay recusado no Android, e custa
		// uma linha.
		function prepararVideo(video) {
			video.muted = true;
			video.defaultMuted = true;
			video.playsInline = true;
		}

		function tocar(video) {
			prepararVideo(video);

			var tocando = video.play();
			if (!tocando || !tocando.catch) return;

			tocando.catch(function () {
				// Recusado (política de autoplay, economia de dados, modo de
				// bateria...). Guardamos para tentar de novo no primeiro toque do
				// visitante: um gesto libera mídia no celular. Até lá fica o
				// poster, que é a própria foto do produto.
				if (bloqueados.indexOf(video) === -1) bloqueados.push(video);
			});
		}

		// Retentativa no gesto do visitante.
		//
		// ERRO QUE ISTO CORRIGE: antes o ouvinte era `once: true`. No celular o
		// primeiro toque é sempre o da ROLAGEM, que acontece ANTES de o card
		// entrar na tela — a fila ainda estava vazia, o ouvinte se removia, e
		// quando o vídeo finalmente era recusado não restava ninguém para tentar
		// de novo. Resultado: ficava o poster para sempre.
		//
		// Agora os ouvintes permanecem (são passivos e o trabalho é mínimo) e
		// tentam o que estiver na tela e parado.
		function destravarNoGesto() {
			var pendentes = bloqueados.slice();
			bloqueados.length = 0;
			pendentes.forEach(function (video) {
				if (video.paused) tocar(video);
			});
		}

		['touchstart', 'pointerdown', 'keydown'].forEach(function (evento) {
			document.addEventListener(evento, destravarNoGesto, { passive: true });
		});

		if (pedeMenosMovimento || !('IntersectionObserver' in window)) {
			// Sem suporte (ou com a preferência ligada) fica o poster, que é a
			// foto do produto — o card continua igual ao de sempre.
			cardVideos.forEach(function (video) { video.pause(); });
		} else {
			var observadorDeVideo = new IntersectionObserver(function (entradas) {
				entradas.forEach(function (entrada) {
					var video = entrada.target;

					if (!entrada.isIntersecting) {
						video.pause();
						return;
					}

					tocar(video);
				});
			}, { threshold: 0.25 });

			cardVideos.forEach(function (video) { observadorDeVideo.observe(video); });
		}
	}

	// ---- Aviso curto (toast) ----
	// Usado hoje só para falha ao adicionar no carrinho. O sucesso já tem
	// retorno próprio (o mini carrinho abre), então não entra toast lá — dois
	// avisos para a mesma ação seria ruído.
	var toastBox = document.getElementById('cnToasts');

	// Texto de reserva, usado quando a falha nem chega ao servidor (rede caiu).
	// Vem do painel via wp_localize_script — ver inc/enqueues.php.
	var erroGenerico = (window.cnCart && window.cnCart.i18n && window.cnCart.i18n.addError) || '';

	function mostrarToast(mensagem) {
		if (!toastBox || !mensagem) return;

		var toast = document.createElement('div');
		toast.className = 'cn-toast cn-toast--error';
		// textContent, não innerHTML: a mensagem vem do WooCommerce (nome do
		// produto cadastrado no wp-admin entra nela) e aqui vale a mesma regra
		// do escHtml acima — texto do banco nunca vira HTML.
		toast.textContent = mensagem;
		toastBox.appendChild(toast);

		// Entra no quadro seguinte para a transição de CSS ter de onde sair.
		requestAnimationFrame(function () { toast.classList.add('is-visible'); });

		setTimeout(function () {
			toast.classList.remove('is-visible');
			setTimeout(function () {
				if (toast.parentNode) toast.parentNode.removeChild(toast);
			}, 350);
		}, 5000);
	}

	// ---- Mini carrinho e falhas do "adicionar ao carrinho" ----
	// O wc-add-to-cart.js do WooCommerce cuida da requisição: põe .loading no
	// botão (o visual dessa classe é do tema, ver _feedback.scss), troca os
	// fragmentos e dispara 'added_to_cart'. Aqui ficam os três pontos que ele
	// não resolve sozinho.
	var mcOverlay = document.getElementById('mcOverlay');

	if (window.jQuery) {
		var $corpo = window.jQuery(document.body);

		// 1. Sucesso abre o mini carrinho — mas SÓ com fragmentos. Numa falha o
		// WooCommerce também dispara 'added_to_cart' (sem fragmentos), e sem
		// esta checagem o mini carrinho abria dizendo "Adicionado ao carrinho"
		// para um produto que não entrou.
		$corpo.on('added_to_cart', function (e, fragments) {
			if (!fragments || !mcOverlay) return;
			document.body.classList.add('mc-open');
		});

		function ehAddToCart(settings) {
			return !!(settings && settings.url && settings.url.indexOf('wc-ajax=add_to_cart') !== -1);
		}

		function destravarBotoes() {
			document.querySelectorAll('.ajax_add_to_cart.loading').forEach(function (botao) {
				botao.classList.remove('loading');
			});
		}

		// 2. Falha com resposta do servidor: o motivo vem em `message` (ver
		// add_to_cart_error_response em inc/woocommerce.php).
		window.jQuery(document).ajaxSuccess(function (e, xhr, settings) {
			if (!ehAddToCart(settings)) return;

			var resposta = xhr && xhr.responseJSON;
			if (!resposta || !resposta.error) return;

			mostrarToast(resposta.message);
			destravarBotoes();
		});

		// 3. Falha de rede: o add-to-cart.js não tem callback de erro para esta
		// requisição, então sem isto o botão ficaria girando para sempre.
		window.jQuery(document).ajaxError(function (e, xhr, settings) {
			if (!ehAddToCart(settings)) return;

			mostrarToast(erroGenerico);
			destravarBotoes();
		});
	}

	function closeMc() { document.body.classList.remove('mc-open'); }
	if (mcOverlay) mcOverlay.addEventListener('click', closeMc);
	document.querySelectorAll('[data-close-mc]').forEach(function (el) { el.addEventListener('click', closeMc); });
	document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMc(); });

	// ---- Formulários decorativos (ex.: newsletter, sem back-end ainda) ----
	document.querySelectorAll('[data-prevent-submit]').forEach(function (form) {
		form.addEventListener('submit', function (e) { e.preventDefault(); });
	});

	// ---- Acordeão de único painel aberto (detalhe do produto e FAQ) ----
	function setupExclusiveAccordion(itemSelector, triggerSelector, symbolSelector) {
		var items = document.querySelectorAll(itemSelector);
		items.forEach(function (item) {
			var trigger = item.querySelector(triggerSelector);
			if (!trigger) return;
			trigger.addEventListener('click', function () {
				var wasOpen = item.classList.contains('is-open');
				items.forEach(function (other) {
					other.classList.remove('is-open');
					var sym = other.querySelector(symbolSelector);
					if (sym) sym.textContent = '+';
				});
				if (!wasOpen) {
					item.classList.add('is-open');
					var sym = item.querySelector(symbolSelector);
					if (sym) sym.textContent = '−';
				}
			});
		});
	}
	setupExclusiveAccordion('.accordion-item', '[data-accordion-trigger]', '.accordion-symbol');
	setupExclusiveAccordion('.faq-item', '[data-faq-trigger]', '.faq-symbol');

	// ---- Seletor de quantidade da página de produto (soma no
	// data-quantity do botão AJAX de adicionar ao carrinho, que fica dentro
	// do mesmo .qty-row — ver single-product.php) ----
	document.querySelectorAll('.qty-row').forEach(function (row) {
		var valEl = row.querySelector('[data-qty-val]');
		var dec = row.querySelector('[data-qty-dec]');
		var inc = row.querySelector('[data-qty-inc]');
		var addBtn = row.querySelector('.add_to_cart_button');
		if (!valEl) return;

		function setQty(v) {
			v = Math.max(1, v);
			valEl.textContent = String(v);
			if (addBtn) addBtn.setAttribute('data-quantity', String(v));
		}

		if (dec) dec.addEventListener('click', function () { setQty(parseInt(valEl.textContent, 10) - 1); });
		if (inc) inc.addEventListener('click', function () { setQty(parseInt(valEl.textContent, 10) + 1); });
	});

	// ---- Máscara de CEP (00000-000) ----
	// Delegada no document porque a calculadora de frete do carrinho é
	// re-renderizada por AJAX pelo cart.js a cada atualização — um listener
	// preso ao input original se perderia depois da primeira consulta.
	document.addEventListener('input', function (e) {
		var el = e.target;
		if (!el || !el.matches || !el.matches('[data-cep-mask], #cepInput')) return;
		var digits = el.value.replace(/\D/g, '').slice(0, 8);
		el.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
	});

	// ---- Consulta de frete por CEP (página de produto) ----
	// Consulta REAL: chama o endpoint cn_shipping_quote (inc/shipping-quote.php),
	// que monta um pacote com o produto e pede as taxas às zonas de entrega do
	// próprio WooCommerce. O valor mostrado aqui é o mesmo que vai aparecer no
	// carrinho. No carrinho não existe esta caixa — lá roda a calculadora nativa
	// do WooCommerce, que além de mostrar também atualiza os totais.
	var cepBox = document.querySelector('[data-shipping-quote]');
	var cepForm = document.getElementById('cepForm');

	if (cepForm && cepBox && typeof cnShipping !== 'undefined') {
		var cepInput = document.getElementById('cepInput');
		var cepResult = document.getElementById('cepResult');
		var cepBtn = cepForm.querySelector('button');
		var t = cnShipping.i18n;

		function cepSay(html, state) {
			cepResult.innerHTML = html;
			cepResult.className = 'cep-check__result' + (state ? ' ' + state : '');
		}

		// (a máscara de 00000-000 é aplicada pelo listener delegado acima)
		cepForm.addEventListener('submit', function (e) {
			e.preventDefault();

			var digits = cepInput.value.replace(/\D/g, '');
			if (digits.length !== 8) {
				cepSay(t.invalid, 'is-error');
				return;
			}

			cepSay(t.loading, '');
			if (cepBtn) cepBtn.disabled = true;

			var body = new URLSearchParams();
			body.append('action', 'cn_shipping_quote');
			body.append('nonce', cnShipping.nonce);
			body.append('cep', digits);
			body.append('product_id', cepBox.getAttribute('data-product-id') || '');
			var qtyEl = document.querySelector('[data-qty-val]');
			body.append('qty', qtyEl ? qtyEl.textContent.trim() : '1');

			fetch(cnShipping.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
				body: body.toString()
			})
				.then(function (r) { return r.json(); })
				.then(function (res) {
					if (!res || !res.success) {
						cepSay((res && res.data && res.data.message) || t.error, 'is-error');
						return;
					}

					var d = res.data;
					if (!d.delivers) {
						cepSay(d.message || t.noDelivery, 'is-error');
						return;
					}

					var linhas = d.rates.map(function (rate) {
						return '<span class="cep-check__rate"><span>' + escHtml(rate.label) + '</span><strong>' + escHtml(rate.cost) + '</strong></span>';
					}).join('');

					cepSay('<span class="cep-check__cep">' + escHtml(d.cep) + '</span>' + linhas, 'is-ok');
				})
				.catch(function () { cepSay(t.error, 'is-error'); })
				.then(function () { if (cepBtn) cepBtn.disabled = false; });
		});
	}

	// ---- Sheet de filtro mobile (loja/categorias) ----
	var filterOverlay = document.getElementById('filterOverlay');
	function openFilters() { document.body.classList.add('filter-open'); }
	function closeFilters() { document.body.classList.remove('filter-open'); }
	document.querySelectorAll('[data-open-filters]').forEach(function (btn) { btn.addEventListener('click', openFilters); });
	if (filterOverlay) filterOverlay.addEventListener('click', closeFilters);
	document.querySelectorAll('[data-close-filters]').forEach(function (el) { el.addEventListener('click', closeFilters); });
	document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilters(); });

	// ---- Ordenação da loja: navega recarregando com ?orderby= (o
	// WooCommerce já sabe ordenar a partir desse parâmetro sozinho) ----
	document.querySelectorAll('[data-sort-nav]').forEach(function (select) {
		select.addEventListener('change', function () {
			var url = new URL(window.location.href);
			url.searchParams.set('orderby', select.value);

			// Volta para a página 1, igual ao cn_url_with() do PHP faz com os
			// chips de tag. A paginação da loja é SEGMENTO DE CAMINHO
			// (/loja/page/2/), então searchParams.delete('paged') sozinho não
			// alcança — e reordenar na página 2 mantinha /page/2/, que vira 404
			// quando a lista nova tem menos páginas.
			url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');
			url.searchParams.delete('paged');

			window.location.href = url.toString();
		});
	});

	// ---- Página do carrinho: setas +/- do .cart-qty escrevem no
	// input.qty real (name="cart[KEY][qty]") e disparam 'change' — o
	// próprio assets/js/frontend/cart.js do WooCommerce já escuta esse
	// evento (ativa o botão "Atualizar carrinho") e faz a atualização via
	// AJAX quando esse botão é clicado. Não reimplementamos a chamada
	// AJAX aqui, só acionamos o fluxo nativo (ver woocommerce/cart/cart.php).
	// Delegado no document (não em cada .cart-qty) porque o próprio
	// cart.js SUBSTITUI o HTML do formulário a cada atualização — um
	// listener direto nos elementos antigos se perderia depois do 1º AJAX. ----
	document.addEventListener('click', function (e) {
		var btn = e.target.closest && e.target.closest('[data-cart-qty-dec], [data-cart-qty-inc]');
		if (!btn) return;
		var qtyWrap = btn.closest('.woocommerce-cart-form .cart-qty');
		if (!qtyWrap) return;
		var input = qtyWrap.querySelector('input.qty');
		if (!input) return;

		var min = parseInt(input.getAttribute('min') || '0', 10);
		var maxAttr = input.getAttribute('max');
		var max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
		var delta = btn.hasAttribute('data-cart-qty-inc') ? 1 : -1;
		var newVal = Math.max(min, Math.min(max, parseInt(input.value, 10) + delta));
		if (newVal === parseInt(input.value, 10)) return;

		input.value = String(newVal);
		input.dispatchEvent(new Event('change', { bubbles: true }));

		var updateBtn = document.querySelector('.woocommerce-cart-form [name="update_cart"]');
		if (updateBtn) updateBtn.click();
	});

	// ---- Cupom do checkout aberto por padrão ----
	// Não basta tirar o style="display:none" do template: o checkout.js do
	// WooCommerce faz `$('form.checkout_coupon').hide()` dentro do próprio
	// init (wc_checkout_coupons.init), que roda no jQuery ready. Por isso a
	// reabertura precisa acontecer DEPOIS desse init — 'load' garante isso,
	// enquanto DOMContentLoaded poderia rodar antes dependendo da ordem em
	// que os scripts registram seus handlers.
	//
	// Só o display é forçado (sem !important no CSS) para o link de
	// mostrar/ocultar continuar funcionando normalmente, e para o slideUp que
	// o checkout.js faz depois de aplicar um cupom não brigar com o CSS.
	window.addEventListener('load', function () {
		var form = document.querySelector('form.checkout_coupon');
		if (!form) return;

		form.style.display = 'block';

		var link = document.querySelector('a.showcoupon');
		if (link) link.setAttribute('aria-expanded', 'true');
	});
})();
